<template>
  <div class="DarkWhite pa-4">
      <v-row class="mb-2">
        <v-col cols="12" sm="6" md="8" lg="9">
        <h2 class="subheading green--text">My Requests</h2>
      </v-col>
      <v-col cols="12" sm="6" md="4" lg="3" class="d-flex justify-center justify-sm-end">
        <v-btn @click="createRequest()" color="header" class="white--text">
          <v-icon class="mr-1">mdi-plus-box-outline</v-icon>
          Create a Request
        </v-btn>
      </v-col>
      </v-row>
      <MyRequests :request="request" />
  </div>
</template>

<script>
import MyRequests from '../components/Utils/MyRequests.vue'
  export default {
    components: {
      MyRequests
    },
    data: () => ({
      request: false,
    }),
    watch: {
    },
    mounted() {
    },
    methods: {
      createRequest(){
        this.request = true;
      }
    //   getFiscalYears() {
    //   this.fiscalyears = [{id: 0, fiscalYear: "All"}]
    //   this.axiosCall("/getAllFiscalYear", "GET").then((res) => {
    //     this.fiscalyears = [{id: 0, fiscalYear: "All"}, ...res.data.data]
    //     this.fiscalYear = this.$store.state.fiscalYear != null ? this.$store.state.fiscalYear : res.data.data[0].id
    //   });
    // },
    }
  }
</script>

<style scoped>
</style>